import {Component, Input, OnInit, Optional} from '@angular/core';
import {FormControl, FormGroup, Validators,} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from '../../../../infrastructure/decorators/auto-unsubscribe.decorator';
import {AdxInvoiceLineItemFilterResult} from '../../model/adx-invoice-line-item-filter-result';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Subscription} from 'rxjs';

@AutoUnsubscribe()
@Component({
    selector: 'adx-invoice-line-items-filter-modal',
    templateUrl: './adx-invoice-line-items-filter-modal.component.html',
    standalone: false
})
export class AdxInvoiceLineItemFilterModalComponent implements OnInit {
  @Input() config!: AdxInvoiceLineItemFilterResult;
  
  breakPoint$?:Subscription;
  isSmall: boolean = false;

  constructor(
    @Optional() public dialogRef: MatDialogRef<AdxInvoiceLineItemFilterModalComponent>,
    breakpointObserver: BreakpointObserver,
  ) {
      this.breakPoint$ = breakpointObserver.observe([
        Breakpoints.Medium,
        Breakpoints.Small,
        Breakpoints.XSmall
      ]).subscribe(result => {
          this.isSmall = result.matches;
      });
  }

  form: FormGroup = new FormGroup({
    quoteID: new FormControl(null,[Validators.pattern(/^[1-9]\d*$/), Validators.min(1)]),
    invoiceRecordLocator: new FormControl(null, Validators.pattern(/^\S*$/)),
    invoiceType: new FormControl(null),
    clientProfileNo: new FormControl(null),
    issueStartDate: new FormControl(null),
    issueEndDate: new FormControl(null),
    createdStartDate: new FormControl(null),
    createdEndDate: new FormControl(null)
  });

  handleAdxInvoiceLineItemFiltersFormCloseEvent() {
    if (!this.dialogRef) {
      return;
    }
    this.dialogRef.close(null);
  }

  ngOnInit() {
    const {quoteID, invoiceRecordLocator, invoiceType, clientProfileNo, issueStartDate, issueEndDate, createdStartDate, createdEndDate} = this.config ?? {};
      
      this.form.patchValue({
        quoteID, invoiceRecordLocator, invoiceType, clientProfileNo, issueStartDate, issueEndDate, createdStartDate, createdEndDate
      });
  }
  applyAdxInvoiceLineItemFilters() {
    
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    
    if (this.dialogRef) {
      const formValues = this.form.value;
      const meaningfulFilters: any = {};
      let hasAnyFilter = false;
      
      for (const [key, value] of Object.entries(formValues)) {
        if (value != null && value !== '' && value !== undefined) {
          if (typeof value === 'string' && value.trim() !== '') {
            meaningfulFilters[key] = value.trim();
            hasAnyFilter = true;
          } else if (typeof value === 'object' && value instanceof Date) {
            meaningfulFilters[key] = value;
            hasAnyFilter = true;
          } else if (typeof value === 'object' && value && 
                     (('value' in value && (value as any).value) || 
                      ('id' in value && (value as any).id))) {
            meaningfulFilters[key] = value;
            hasAnyFilter = true;
          } else if (typeof value !== 'object' && value !== '') {
            meaningfulFilters[key] = value;
            hasAnyFilter = true;
          }
        }
      }
      
      this.dialogRef.close(hasAnyFilter ? meaningfulFilters : null);
    }
  }

  public clearFilters(propertyName: string): void {
    if (propertyName === 'all') {
      this.form.reset();
      this.config = {} as AdxInvoiceLineItemFilterResult;
    } else {
      this.form.get(propertyName)?.setValue(null);
      
      const temp = { ...this.config };
      delete temp[propertyName as keyof AdxInvoiceLineItemFilterResult];
      this.config = temp;
    }
  }
}
